import { ChannelkartNetworkGet } from './networkService';


// export const fetchChannels = async () => {
//   const api = '/v1/distinctFieldData/OutletDetails/channel';
//   const response = await ChannelkartNetworkGet(api);
//   return response.data; 
// };

// export const fetchLoyaltyTypes = async () => {
//   const api = '/v1/distinctFieldData/OutletDetails/outletClass';
//   const response = await ChannelkartNetworkGet(api);
//   return response.data;
// };


// export const fetchOutletTypes = async () => {
//   const api = '/v1/distinctFieldData/OutletDetails/outletType';
//   const response = await ChannelkartNetworkGet(api);
//   return response.data;
// };


export const fetchDistinctOutletField = async (field: string) => {
  const api = `/v1/distinctFieldData/OutletDetails/${field}?size=1000`;
  const response = await ChannelkartNetworkGet(api);
  return response.data;
};

